import type { AxiosResponse } from "axios";

import type {
  CancelableAxiosPromise,
  S3PutSuccess,
} from "cortex/ui/src/service/base";
import { baseService } from "cortex/ui/src/service/base";

export interface IncidentComment {
  comment: string;
  create_date: string;
  id: number;
  incident_id: number;
  user_id: number;
}

interface IncidentCommentResponse {
  data: IncidentComment;
}

interface IncidentCommentsResponse {
  data: ReadonlyArray<IncidentComment>;
}

interface BulkIncidentCommentsResponse {
  data: ReadonlyArray<IncidentComment>;
}

export const incidentsService = {
  loadByDeviceId(deviceId: string): CancelableAxiosPromise {
    return baseService.get(`/api/incidents/device/${deviceId}`);
  },

  load(): CancelableAxiosPromise {
    return baseService.get("/api/incidents/");
  },

  resolve(
    incidentId: number,
    data: unknown,
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put(`/api/incidents/${incidentId}`, data);
  },

  resolveBulk(data: unknown): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put("/api/incidents/", data);
  },

  updateStatus(
    incidentId: number,
    status: string,
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put(`/api/incidents/${incidentId}/status`, { status });
  },

  get(incidentId: number): CancelableAxiosPromise {
    return baseService.get(`/api/incidents/${incidentId}`);
  },

  loadComments(
    incidentId: number,
  ): CancelableAxiosPromise<IncidentCommentsResponse> {
    return baseService.get(`/api/incidents/${incidentId}/comments`);
  },

  addComment(
    incidentId: number,
    comment: string,
  ): CancelableAxiosPromise<IncidentCommentResponse> {
    return baseService.post(`/api/incidents/${incidentId}/comments`, {
      comment,
    });
  },

  addComments(
    incidentIds: ReadonlyArray<number>,
    comment: string,
  ): CancelableAxiosPromise<BulkIncidentCommentsResponse> {
    return baseService.post("/api/incidents/bulk-comment", {
      comment,
      incident_ids: incidentIds,
    });
  },
};

export default incidentsService;
